import { render } from "./PopElgmov.vue?vue&type=template&id=715d55ee&scoped=true"
import script from "./PopElgmov.vue?vue&type=script&lang=js"
export * from "./PopElgmov.vue?vue&type=script&lang=js"

import "./PopElgmov.vue?vue&type=style&index=0&id=715d55ee&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715d55ee"]])

export default __exports__